module.exports = __webpack_public_path__ + "img/product-icon_5.249d5f58.png";